

import Vue from "vue";
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import {Contact, Project} from "@/models/base";

export default Vue.extend({
	data(){
		return {
			contactGroupId: 1
		};
	},
	props: {
		project: {
			required: true,
			type: Object as () => Project
		},
	},
	computed: {},
	methods: {
		selectContact(contact: Contact){
			this.project.Contact = contact;
			this.project.ContactID = contact.ID;
		}
	},
	components: {
		AppContactSearch,
	},
	i18nEx: {
		componentPrefix: "components.crm"
	}
});
	